/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/login': {
    width: 22,
    height: 12,
    viewBox: '0 0 22 12',
    data: '<defs><path pid="0" d="M11.648 4.002a5.998 5.998 0 00-6.88-3.88c-2.29.46-4.15 2.29-4.63 4.58a6.006 6.006 0 005.86 7.3 5.99 5.99 0 005.65-4h4.35v2c0 1.1.9 2 2 2s2-.9 2-2v-2c1.1 0 2-.9 2-2s-.9-2-2-2h-8.35zm-5.65 4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" id="svgicon_headerIcons_login_a"/></defs><use _fill="#000" xlink:href="#svgicon_headerIcons_login_a" fill-rule="evenodd"/>'
  }
})
